import React, { useState } from "react";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

const renderWithLinks = (text) =>
  text.split(URL_REGEX).map((part, i) =>
    URL_REGEX.test(part) ? (
      <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
    ) : (
      part
    )
  );

const FAQModal = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      time: "1:57 PM",
      user: "what programs/software do you use?",
      isUser: true,
    },
    {
      id: 2,
      time: "1:58 PM",
      user: "i use procreate and clip studio paint EX interchangeably for my illustrations and comics!",
      isUser: false,
    },
    {
      id: 3,
      time: "1:59 PM",
      user: "can i repost your work?",
      isUser: true,
    },
    {
      id: 4,
      time: "2:00 PM",
      user: `i do not allow unauthorized republishing of my artwork.\nif you get permission from me to reshare my art, please provide credit to where you found it and do not remove my watermark under any circumstances.\nunpermitted usage: \n♛ reposting on any platform\n♛ tracing, reproducing, ai-generation\n♛ commercial purposes`,
      isUser: false,
    },
    {
      id: 5,
      time: "2:01 PM",
      user: "are your commissions open?",
      isUser: true,
    },
    {
      id: 6,
      time: "2:02 PM",
      user: `for personal commission work, please dm any of my socials for details and availability.\nfor larger projects or freelance inquiries, you may also email me at koyasumiis@gmail.com.\nyou can find my terms of services here: https://koyasumi.carrd.co/#terms`,
      isUser: false,
    },
    {
      id: 7,
      time: "2:03 PM",
      user: "pronouns?",
      isUser: true,
    },
    {
      id: 8,
      time: "2:04 PM",
      user: "i don’t mind what pronouns you use for me if you know me personally, but i exclusively prefer they/them otherwise.",
      isUser: false,
    },
    {
      id: 9,
      time: "2:05 PM",
      user: "can i use your MISFITS AU artwork as reference for my own project? can i write a fanfiction based on your AU?",
      isUser: true,
    },
    {
      id: 10,
      time: "2:06 PM",
      user: `i get this question a lot ^^; while i’m really flattered that my work could serve as inspiration for others, i am not comfortable with any part of my AU being reproduced or used as reference for other projects because it is still in the process of being developed.\nmaybe in the future i will be more open to the idea of allowing supplementary works, but for now, i am not okay with it. i hope you understand.`,
      isUser: false,
    },
    {
      id: 11,
      time: "2:07 PM",
      user: "can i make fanart of your AUs?",
      isUser: true,
    },
    {
      id: 12,
      time: "2:08 PM",
      user: "absolutely!! please tag or message me if you do!",
      isUser: false,
    },
    {
      id: 13,
      time: "2:09 PM",
      user: "can i use your work as my icon/header/wallpaper?",
      isUser: true,
    },
    {
      id: 14,
      time: "2:10 PM",
      user: "it depends on the artwork. if you’re unsure, please just message me and ask! most times i’ll accept if you ask politely. ^^ ",
      isUser: false,
    },
    {
      id: 15,
      time: "2:11 PM",
      user: "can i send you a message? i need art advice! (or for any other reason)",
      isUser: true,
    },
    {
      id: 16,
      time: "2:12 PM",
      user: "of course! you are welcome to dm me about anything, and i will try to respond when i can! just please be mindful about what you message me about, because i may not respond if i feel uncomfortable answering.",
      isUser: false,
    },
  ]);
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (input.trim()) {
      setMessages([
        ...messages,
        { id: messages.length + 1, time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), user: input, isUser: true },
      ]);
      setInput("");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="faq-modal-overlay" onClick={onClose}>
      <div className="faq-modal" onClick={(e) => e.stopPropagation()}>
        <button className="faq-modal-close" onClick={onClose}>✕</button>

        <div className="faq-header">
          <div className="faq-title">
            <span className="faq-number">(16)</span>
            <span className="faq-label">FAQ</span>
          </div>
        </div>

        <div className="faq-messages">
          {messages.map((msg) => (
            <div key={msg.id} className={`message ${msg.isUser ? "user" : "other"}`}>
              <span className="time">{msg.time}</span>
              <div className="bubble">{renderWithLinks(msg.user)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQModal;